import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import {
  LOGIN_UP,
  VERIFY_PASSWORD_RESET_OTP,
} from "../../graphql/mutations/signUp";
import Login from "../../components/Login/Login";
import { useDispatch, useSelector } from "react-redux";
import { loginAction, setError, setLoading } from "../../store/auth/authSlice";
import { useEffect, useState } from "react";
import { RootState } from "../../store/rootReducer";
import { LoadingSpinner, Overlay } from "../AddUserPage/AddUser";
import { toast } from "react-toastify";
import { setUserData } from "../../store/user";
import { clearStorage } from "../../store";
import ResetPassword from "../../components/ForgotPassword/ResetPassword";

export interface ResetPasswordFormValues {
  otp: string;
  newPassword: string;
}

const ResetPasswordPage: React.FC = () => {
  const [reloadCount, setReloadCount] = useState<number>(0);
  const [resetPassword, { loading }] = useMutation(VERIFY_PASSWORD_RESET_OTP, {
    errorPolicy: "all",
  });
  const [formData, setFormData] = useState<ResetPasswordFormValues>({
    otp: "",
    newPassword: "",
  });
  const token = useSelector((state: RootState) => state.token.token);
  const isLoggedIn = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleResetPassword = async () => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(""));
      const response = await resetPassword({
        variables: {
          otp: formData.otp,
          newPassword: formData.newPassword,
          token: token,
        },
      });

      if (response.data.verifyAndResetPasswordOtp.success === true) {
        const { success, message } = response.data.verifyAndResetPasswordOtp;

        // dispatch(loginAction({ accessToken }));
        dispatch(
          setUserData({
            success,
            message,
          })
        );

        navigate("/auth/login");
      } else {
        dispatch(setError("Reset Password failed. Please check your OTP."));
      }
    } catch (error: any) {
      const message = `Reset Password failed. Please check your OTP.`;
      dispatch(setError(message));
      toast.error(message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      {loading && (
        <Overlay>
          <LoadingSpinner />
        </Overlay>
      )}
      <ResetPassword
        handleResetPassword={handleResetPassword}
        formData={formData}
        setFormData={setFormData}
        isLoading={loading}
      />
    </>
  );
};

export default ResetPasswordPage;
